import {Component, Input, OnInit} from '@angular/core';
import {ConferenceEvent} from '../../model/ConferenceEvent';
import {AbstractsService} from '../../service/abstracts.service';
declare var MathJax:any;

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css']
})
export class EventComponent implements OnInit {

  @Input()
  conferenceEvent: ConferenceEvent;

  show = false;

  constructor(private abstractsService : AbstractsService) { }

  ngOnInit() {
  }
  public showTime(): boolean {
    return this.conferenceEvent.time !== '';
  }
  public showAnnouncement(): boolean {
    return this.conferenceEvent.eventType !== "LECTURE";
  }

  public showSpeakerAndTitleShw(): boolean{
    return this.conferenceEvent.eventType === "LECTURE";
  }

  public getAbstract(link: string): string {
    if (link === ""){
      return "";
    }
    return this.abstractsService.getAbstract(link);
  }

  showAbstrac(){
    return this.show;
  }

  showHideAbstract(){
    if (this.conferenceEvent.speakerLink === "" ) {
      return;
    }
    this.show = !this.show;
    setTimeout(() => { MathJax.Hub.Queue(["Typeset",MathJax.Hub])}, 500);
  }

  mathjax(){
    MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
  }

}



// WEBPACK FOOTER //
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/program/event/event.component.ts